var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-image-slider carousel-box"},[_c('div',{ref:"carousel",staticClass:"owl-carousel owl-theme"},_vm._l((_vm.sliderData),function(sliderImage,index){return _c('AtomsCommonSliderAtomImageSliderMatterportSpace',{key:index,attrs:{"slider-image":sliderImage}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }